/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type EditCashbackForm_lists$ref: FragmentReference;
declare export opaque type EditCashbackForm_lists$fragmentType: EditCashbackForm_lists$ref;
export type EditCashbackForm_lists = {|
  +stores: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>
  |},
  +$refType: EditCashbackForm_lists$ref,
|};
export type EditCashbackForm_lists$data = EditCashbackForm_lists;
export type EditCashbackForm_lists$key = {
  +$data?: EditCashbackForm_lists$data,
  +$fragmentRefs: EditCashbackForm_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditCashbackForm_lists",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "active",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "StoreConnection",
      "kind": "LinkedField",
      "name": "stores",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Store",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "stores(active:false,first:1000)"
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = 'f2989732f46f5d878088a2ce5538cdd6';

module.exports = node;
